import { Dispatch } from "redux"

import ApiProducts from "api/ApiProducts"
import { CLOSE_MODAL, OPEN_MODAL, SET_PRODUCT, CLEAR_PRODUCT, SET_PRODUCT_IDENTIFIERS } from "./actions-types"
import { ProductValidations } from "./ProductValidations"

const validate = new ProductValidations()

export function changeModalState(isOpen: boolean, type: string) {
  return (dispatch: Dispatch) => {
    if (isOpen) return dispatch({ type: OPEN_MODAL, payload: { type } })

    return dispatch({ type: CLOSE_MODAL })
  }
}

export function setProduct(params: App.Product) {
  return (dispatch: Dispatch) => {
    dispatch({ type: SET_PRODUCT, payload: params })
  }
}

export function clearProduct() {
  return (dispatch: Dispatch) => {
    dispatch({ type: CLEAR_PRODUCT })
  }
}

export function createProduct(product: App.Product) {
  return async (dispatch: Dispatch) => {
    const { isInvalid, msg } = validate.isInvalidCreateInput(product)

    if (isInvalid) return msg

    const { status } = await new ApiProducts().create(product)

    return validate.response(status, dispatch)
  }
}

export function updateProduct(actual: App.Product, prefixUrl: string) {
  return async (dispatch: Dispatch) => {
    const response = await new ApiProducts().updateByPrefixUrl(actual, prefixUrl)

    return validate.response(response.status, dispatch)
  }
}

export function deleteProduct(prefixUrl: string) {
  return async (dispatch: Dispatch) => {
    const response = await new ApiProducts().deleteByPrefixUrl(prefixUrl)

    return validate.response(response.status, dispatch)
  }
}

export function setProductIdentifiers(data: { productPrefixUrl: string; productId: string }) {
  return (dispatch: Dispatch) => {
    return dispatch({ type: SET_PRODUCT_IDENTIFIERS, payload: data })
  }
}
